module.exports = "<div class=\"btn-group\" *ngFor=\"let item of list;\">\n  <label class=\"btn btn-primary waves-light\" (click)=\"showChildren(item.cod)\" [(ngModel)]=\"radioModel\" mdbRadio=\"{{item.cod}}\" mdbWavesEffect>\n    {{item.nombre}}\n  </label>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/tabs/menu/menu.component.html
// module id = ./src/app/shared/components/tabs/menu/menu.component.html
// module chunks = main